"use client";

import React from "react";

interface BodyLineTextProps {
  children: React.ReactNode;
  wrapperClassName?: string;
  textClassName?: string;
  className?: string;
}

export default function BodyLineText({
  children,
  wrapperClassName = "",
  textClassName = "",
  className = "",
}: BodyLineTextProps) {
  return (
    <div
      className={`flex justify-center items-center text-center px-0 pt-4 md:pt-8 lg:pt-8 w-full lg:max-w-[80%] ${wrapperClassName} ${className}`}
    >
      <p
        className={`w-full ${textClassName} text-md sm:text-md md:text-2xl lg:text-2xl font-normal text-[#000429] opacity-70`}
      >
        {children}
      </p>
    </div>
  );
}
